import * as React from "react";

const BlueFileImage: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width="158.000000pt"
            height="158.000000pt"
            viewBox="0 0 158.000000 158.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,158.000000) scale(0.100000,-0.100000)" fill="#275AA8" stroke="none">
                <path d="M652 1474 c-19 -13 -22 -24 -22 -79 l0 -63 -96 -4 c-114 -4 -124 -11 -124 -99 l0 -58 -166 -3 -166 -3 -24 -28 -24 -28 0 -450 c0 -275 4 -457 10 -469 20 -38 55 -40 657 -40 l584 0 24 25 c24 24 25 28 25 180 l0 155 35 0 c25 0 44 8 60 25 23 22 25 32 25 120 l0 95 34 0 c65 0 66 4 66 377 0 288 -2 334 -16 347 -14 14 -67 16 -437 16 -366 0 -426 -2 -445 -16z m838 -344 c0 -293 0 -300 -20 -300 -19 0 -20 7 -20 228 0 181 -3 232 -14 248 -14 18 -31 19 -370 22 l-356 3 0 49 0 50 390 0 390 0 0 -300z m-120 -210 c0 -321 -1 -330 -20 -330 -18 0 -19 10 -22 271 l-3 271 -24 19 c-22 18 -44 19 -417 19 l-394 0 0 40 0 40 440 0 440 0 0 -330z m-140 -260 l0 -410 -540 0 -540 0 0 410 0 410 540 0 540 0 0 -410z" />
                <path d="M355 921 c-64 -27 -81 -110 -32 -158 60 -61 162 -19 162 67 0 66 -72 116 -130 91z" />
                <path d="M790 598 c-52 -60 -105 -119 -118 -131 l-23 -21 -83 83 -83 83 -127 -149 -127 -148 230 -3 c127 -1 334 -1 459 0 l229 3 -131 196 -131 197 -95 -110z" />
            </g>
        </svg>
    );
};

export default React.memo(BlueFileImage);
